import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "./GeographicTransformationStep.js";

var s = /*#__PURE__*/function () {
  function s(_s) {
    _classCallCheck(this, s);

    if (this.steps = [], this._cached_projection = {}, this._chain = "", this._gtlistentry = null, _s && _s.steps) {
      var _iterator = _createForOfIteratorHelper(_s.steps),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var i = _step.value;
          i instanceof t ? this.steps.push(i) : this.steps.push(new t({
            wkid: i.wkid,
            wkt: i.wkt,
            isInverse: i.isInverse
          }));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }

  _createClass(s, [{
    key: "getInverse",
    value: function getInverse() {
      var t = new s();
      t.steps = [];

      for (var _s7 = this.steps.length - 1; _s7 >= 0; _s7--) {
        var i = this.steps[_s7];
        t.steps.push(i.getInverse());
      }

      return t;
    }
  }, {
    key: "getGTListEntry",
    value: function getGTListEntry() {
      var t = "";

      var _iterator2 = _createForOfIteratorHelper(this.steps),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _s8 = _step2.value;
          t += _s8.uid.toString() + ",";
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return t !== this._chain && (this._gtlistentry = null, this._cached_projection = {}, this._chain = t), this._gtlistentry;
    }
  }, {
    key: "assignCachedGe",
    value: function assignCachedGe(t, i, e) {
      this._cached_projection[s.cacheKey(t, i)] = e;
    }
  }, {
    key: "getCachedGeTransformation",
    value: function getCachedGeTransformation(t, i) {
      var e = "";

      var _iterator3 = _createForOfIteratorHelper(this.steps),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _s9 = _step3.value;
          e += _s9.uid.toString() + ",";
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      e !== this._chain && (this._gtlistentry = null, this._cached_projection = {}, this._chain = e);

      var n = this._cached_projection[s.cacheKey(t, i)];

      return void 0 === n ? null : n;
    }
  }], [{
    key: "cacheKey",
    value: function cacheKey(t, _s2) {
      return [void 0 !== t.wkid && null !== t.wkid ? t.wkid.toString() : "-1", void 0 !== t.wkt && null !== t.wkt ? t.wkt.toString() : "", void 0 !== _s2.wkid && null !== _s2.wkid ? _s2.wkid.toString() : "-1", void 0 !== _s2.wkt && null !== _s2.wkt ? _s2.wkt.toString() : ""].join(",");
    }
  }, {
    key: "fromGE",
    value: function fromGE(i) {
      var e = new s();
      var n = "";

      var _iterator4 = _createForOfIteratorHelper(i.steps),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _s10 = _step4.value;

          var _i = t.fromGE(_s10);

          e.steps.push(_i), n += _i.uid.toString() + ",";
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return e._cached_projection = {}, e._gtlistentry = null, e._chain = n, e;
    }
  }]);

  return s;
}();

export { s as default };